import request from '@/router/axios'
import env from '@/config/env'
import globalVariable from '@/config/globalVariable'

const { TIME } = globalVariable

// 获取列表
export const pageApi = (params) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/listAppPaymentChannelConfig',
    method: 'POST',
    timeout: TIME,
    data: params
  })
}
// 获取商户支付资料列表
export const merchantPageApi = () => {
  return request({
    url: env.ferryUrl + '/appPayConfig/listPayMerchant',
    method: 'GET',
    timeout: TIME
  })
}
// 获取应用列表
export const appPage = (params) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/listApp',
    method: 'GET',
    timeout: TIME
  })
}
// 支付渠道列表
export const listPayChannel = () => {
  return request({
    url: env.ferryUrl + '/appPayConfig/listPayChannel',
    method: 'GET',
    timeout: TIME
  })
}
// 支付渠道列表
export const listPayChannelByAppInfoId = (data) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/listPayChannelByAppInfoId',
    method: 'GET',
    timeout: TIME,
    params: data
  })
}

// 根据支付渠道获取商户实体列表
export const listPayMerchant = (params) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/listPayMerchantByPayChannelId',
    method: 'GET',
    timeout: TIME,
    params: {
      ...params
    }
  })
}

// 根据商户实体获取商户号列表
export const merchantEntity = (params) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/listPayMerchantByMerchantEntityName',
    method: 'GET',
    timeout: TIME,
    params: {
      ...params
    }
  })
}

// 修改应用支付配置
export const updateConfig = (params) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/updateAppPaymentChannelConfig',
    method: 'post',
    timeout: TIME,
    data: params
  })
}

// 添加商户支付资料
export const addPayMerchant = (params) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/addPayMerchant',
    method: 'post',
    timeout: TIME,
    data: params
  })
}
// 更新商户支付资料
export const updatePayMerchant = (params) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/updatePayMerchant',
    method: 'post',
    timeout: TIME,
    data: params
  })
}

// 删除商户支付资料
export const delPayMerchant = (params) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/delPayMerchant',
    method: 'GET',
    timeout: TIME,
    params: {
      ...params
    }
  })
}
// 停用商户支付资料
export const stopPayMerchant = (params) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/stopPayMerchant',
    method: 'GET',
    timeout: TIME,
    params: {
      ...params
    }
  })
}
// 启用商户支付资料
export const openPayMerchant = (params) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/openPayMerchant',
    method: 'GET',
    timeout: TIME,
    params: {
      ...params
    }
  })
}

// 删除支付渠道
export const delPayChannel = (params) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/delPayChannel',
    method: 'GET',
    timeout: TIME,
    params: {
      ...params
    }
  })
}

// 应用支付配置操作日志
export const configLog = (params) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/appPaymentChannelConfigLog',
    method: 'GET',
    timeout: TIME,
    params: {
      ...params
    }
  })
}

// 切支付短信验证手机号码
export const authMoblie = () => {
  return request({
    url: env.ferryUrl + '/appPayConfig/authMoblie',
    method: 'GET',
    timeout: TIME
  })
}

// 向切支付短信验证手机号码发送验证码
export const sendAuthMoblieCode = () => {
  return request({
    url: env.ferryUrl + '/appPayConfig/sendAuthMoblieCode',
    method: 'GET',
    timeout: TIME
  })
}
// 主体列表
export const listEntity = () => {
  return request({
    url: env.ferryUrl + '/appPayConfig/listEntity',
    method: 'GET',
    timeout: TIME
  })
}

// 修改主体列表
export const addEntity = (params) => {
  return request({
    url: env.ferryUrl + '/appPayConfig/addEntity',
    method: 'POST',
    timeout: TIME,
    data: params
  })
}
